import React, { useState } from "react";
import { postData } from "../../../services/Axios/Axios";
import { Briefcase, CircleX } from "lucide-react";
import { ApiUrl } from "../../../config/apiConfig";
import { showErrorToast, showSuccessToast } from "../../../utils/utils";
import PrimaryButton from "../../UIElements/PrimaryButton";


interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    currentJobCategoryId:string;
}

const BulkJobUploadModal: React.FC<Props> = ({ isOpen, onClose, onSuccess ,currentJobCategoryId }) => {
    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleUpload = async () => {
        if (!file) {
            showErrorToast("Please select a CSV file");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("categoryId", currentJobCategoryId);


        setLoading(true);

        try {
            const res = await postData(ApiUrl.jobBulkUpload, formData);

            const { inserted, failed } = res?.data || {};

            showSuccessToast(
                `Upload finished. Inserted: ${inserted ?? 0}, Failed: ${failed ?? 0}`
            );

            onSuccess?.();
            setFile(null);
            onClose();

        } catch (e: any) {
            showErrorToast(
                e?.response?.data?.message ?? "Bulk upload failed"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="w-full max-w-md rounded-xl bg-white shadow-xl animate-fadeIn flex flex-col">

                {/* HEADER */}
                <div
                    className="flex self-start gap-[10px] h-[45px] justify-between items-center text-white w-full 
                    bg-gradient-to-r from-[#007070] via-[#06baba] to-[#007070] 
                    bg-[length:200%_200%] animate-[gradient-x_4s_ease_infinite] 
                    py-1 px-4 rounded-t-[8px] shadow-md"
                >
                    <div className="flex items-center space-x-2">
                        <Briefcase />
                        <h2 className="text-lg font-semibold text-white tracking-wide">
                            Bulk Upload Jobs (CSV)
                        </h2>
                    </div>

                    <CircleX
                        size={20}
                        className="bg-white text-greenBg rounded-full hover:p-1 cursor-pointer transition-all duration-500 hover:rotate-180"
                        onClick={onClose}
                    />
                </div>

                {/* BODY */}
                <div className="px-4 py-4">
                    <div className="flex flex-col gap-3">

                        <label className="text-[#999999] text-[14px]">
                            Select CSV file
                        </label>

                        <input
                            type="file"
                            accept=".csv"
                            onChange={(e) => setFile(e.target.files?.[0] || null)}
                            className="text-[13px]"
                        />

                        {file && (
                            <div className="text-[12px] text-gray-600">
                                Selected: {file.name}
                            </div>
                        )}

                        <div className="flex justify-end mt-2">
                            <PrimaryButton
                                disabled={loading}
                                onClick={handleUpload}
                                label="Upload CSV"
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default BulkJobUploadModal;
